export default {
  SET_LOCALE: '@AUTH_GATEWAY/I18N/SET_LOCALE',
};
